import {useEffect, useState} from 'react';

import { Slide } from 'react-awesome-reveal';

import { useApp } from '../app-context';
import { ChatService } from '../services/ChatService'
import { TSPage } from '../components/commons';

import './BankDetailsPage.scss';

const BankDetailsPage = function ({ name, onBack, data, btn }) {
    const [state, dispatcher] = useApp();
    const [stateDetails, setStateDetails] = useState({
        ...data?.["claim.policyDetails"],
    });
    const [stateErrors, setStateErrors] = useState({});
    const [stateBusy, setStateBusy] = useState(false);
    const [stateSelectedOtherPerson, setStateSelectedOtherPerson] = useState(false);
    const [stateDisabled, setStateDisabled] = useState({});

    useEffect(() => {
        let disabled = {};
        if (!stateSelectedOtherPerson) {
            ["customerFirstName", "customerLastName", "customerPId"].forEach(key => {
                if (data?.["claim.policyDetails"][key])
                    disabled[key] = true;
            })
        }
        setStateDisabled(disabled);
    }, [stateSelectedOtherPerson]);

    const handleSelectOtherPerson = (e) => {
        let sd = { ...stateDetails, otherPerson: !stateSelectedOtherPerson };
        if (sd.otherPerson) {
            sd = {...sd, customerFirstName: "", customerLastName: "", customerPId: ""};
        } else {
            sd = {
                ...data?.["claim.policyDetails"],
                otherPerson: false
            };
        }
        setStateDetails(sd);
        setStateSelectedOtherPerson(!stateSelectedOtherPerson);
        setStateErrors({});
    }

    const handleBack = (e) => {
        if (stateBusy) return;

        if (onBack)
            onBack(true, e);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (stateBusy) return;

        if (!validateFields()) {
            return;
        }

        let answer = {
            display: "התקבלו פרטי חשבון",
            value: stateDetails,
            id: btn?.id,
            field: btn?.field
        }

        setStateBusy(true);
        ChatService.processAnswer(dispatcher, state, answer)
            .then(() => {
                dispatcher({ action: 'closeOverlay', params: 'bankAccount' });
            })
            .catch(ex => {
                alert(ex);
            }).finally(() => {
                setStateBusy(false);
            });
    };

    const validateFields = function () {
        var errors = {};
        if (!stateDetails.bank)
            errors.bank = "חובה להזין את שם הבנק";

        if (!stateDetails.branch)
            errors.branch = "יש להזין את מספר הסניף";

        if (isNaN(stateDetails.branch * 1))
            errors.branch = "על הסניף להיות מספר בלבד";

        if (!stateDetails.account)
            errors.account = "יש להזין את מספר החשבון";

        if (isNaN(stateDetails.account * 1))
            errors.account = "על החשבון להיות מספר בלבד";

        if (!stateDetails.customerFirstName)
            errors.customerFirstName = "יש להזין שם פרטי";

        if (!stateDetails.customerLastName)
            errors.customerLastName = "יש להזין שם משפחה";

        if (!stateDetails.customerPId)
            errors.customerPId = "יש להזין את מספר תעודת הזיהוי";

        setStateErrors(errors);
        return Object.keys(errors).length === 0;
    }

    const onFieldChange = function (id, e) {
        const cs = { ...stateDetails };
        cs[id] = e.target.value;
        setStateDetails(cs);
    }

    const cb = (_inview, ioe) => { ioe.target.querySelector(".container").classList.add("on"); }

    data = data || {};
    return (
        <TSPage name={name}>
            <Slide direction="up" duration="500" onVisibilityChange={cb}>
                <div className="container on">
                    <div className="header">
                        <button className="btn right" onClick={handleBack}>
                            <img src="img/right-arrow.svg" alt="back" />
                        </button>
                        <div className="title">
                            פרטי חשבון בנק
                        </div>
                    </div>
                    <div className="content" style={{ marginLeft: -state?.uiParams?.scrollSize?.w + "px" }}>
                        <div className="top">
                            <form onSubmit={handleSubmit}>
                                <h5>יש לאשר את פרטי חשבון הבנק של בעל הפוליסה בלבד</h5>
                                <div key="otherPersonSelect" className={"otherPerson" + (stateSelectedOtherPerson ? " selected" : "")} onClick={handleSelectOtherPerson}>
                                    <div className="selector"><img src={"img/circle-selector-" + (stateSelectedOtherPerson ? "full-white" : "empty") + ".svg"} alt="" /></div>
                                    <div className="txt">אני בכל זאת רוצה שהתשלום יגיע לאדם אחר</div>
                                </div>
                                {stateSelectedOtherPerson ?
                                <div id="otherPersonAdded" className="otherPersonAdded">
                                    <div className="txt">אם התביעה תאושר ובהתאם להנחיית משרד האוצר, ההחזר הכספי צריך להיעשות לבעל הפוליסה בלבד. למרות זאת, אנחנו יכולים לבצע את התשלום לאדם אחר. במקרה זה, נבקש לבצע את השלבים הבאים:</div>
                                    <ol>
                                        <li>יש ללחוץ על הכפתור למטה ולהוריד את טופס המחאת הזכות, ואז  להדפיס ולמלא אותו. ניתן לפנות לשירות הלקוחות שלנו בכל שאלה.</li>
                                        <a href="https://assets.chayuta.com/shomera/payer-transfer-rights.pdf" download="Proposed_Filename" target="_blank">
                                            <img src="img/button-download.svg" alt="Download Icon" />
                                        </a>
                                        <li>יש לחתום עליו בכתב ידך ולאמת אותו על ידי עורך דין.</li>
                                        <li>יש לסרוק את הטופס החתום ולצרפו בהמשך במסך העלאת מסמכים.</li>
                                    </ol>
                                    <div className='txtBold'> לתשומת לבך <span className="redHeart">❤</span></div>
                                    <div className="info">
                                        <div className="img"><img src="img/info.svg" alt="" /></div>
                                        <div className='txt'>אי אפשר להשלים את תהליך הגשת התביעה בלי המחאת זכות חתומה ומאומתת.</div>
                                    </div>
                                </div>
                                : undefined }
                                <div className={"row double"}>
                                    <div className="part">
                                        <label>שם פרטי</label>
                                        <input type="text" name="customerFirstName" value={stateDetails.customerFirstName} onChange={onFieldChange.bind(this, "customerFirstName")} className={stateErrors.customerFirstName && "error"} disabled={stateDisabled.customerFirstName}></input>
                                        <div className={"validationError " + (stateErrors.customerFirstName && "on")}>{stateErrors.customerFirstName}</div>
                                    </div>
                                    <div className="part">
                                        <label>שם משפחה</label>
                                        <input type="text" name="customerLastName" value={stateDetails.customerLastName} onChange={onFieldChange.bind(this, "customerLastName")} className={stateErrors.customerLastName && "error"} disabled={stateDisabled.customerLastName}></input>
                                        <div className={"validationError " + (stateErrors.customerLastName && "on")}>{stateErrors.customerLastName}</div>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className="part single">
                                        <label>מספר ת"ז</label>
                                        <input type="number" name="customerPId" value={stateDetails.customerPId} onChange={onFieldChange.bind(this, "customerPId")} className={stateErrors.customerPId && "error"} disabled={stateDisabled.customerPId}></input>
                                        <div className={"validationError " + (stateErrors.customerPId && "on")}>{stateErrors.customerPId}</div>
                                    </div>
                                </div>
                                <div className="row">
                                    <label>שם בנק</label>
                                    <select name="bank" onChange={onFieldChange.bind(this, "bank")} className={stateErrors.bank && "error"}>
                                        <option value="">בחר</option>
                                        <option value="1">בנק  יורו</option>
                                        <option value="26">בנק U</option>
                                        <option value="14">בנק אוצר החייל</option>
                                        <option value="13">בנק איגוד</option>
                                        <option value="11">בנק דיסקונט</option>
                                        <option value="9">בנק הדואר</option>
                                        <option value="18">בנק וואן זירו</option>
                                        <option value="19">בנק החקלאות לישראל</option>
                                        <option value="8">בנק הספנות לישראל</option>
                                        <option value="12">בנק הפועלים</option>
                                        <option value="4">בנק יהב לעובדי מדינה</option>
                                        <option value="54">בנק ירושלים</option>
                                        <option value="10">בנק לאומי/הישיר הראשון</option>
                                        <option value="7">בנק לפיתוח התעשייה</option>
                                        <option value="20">בנק מזרחי-טפחות</option>
                                        <option value="46">בנק מסד</option>
                                        <option value="17">בנק מרכנתיל דיסקונט</option>
                                        <option value="47">בנק עולמי להשקעות</option>
                                        <option value="34">בנק ערבי ישראלי</option>
                                        <option value="35">בנק פולסקא/פאקאו</option>
                                        <option value="52">בנק פועלי אגודת ישראל</option>
                                        <option value="28">בנק קונטיננטל</option>
                                        <option value="48">בנק קופת העובד הלאומי לאשראי וחסכון בנתניה</option>
                                        <option value="31">הבנק הבינלאומי הראשון</option>
                                        <option value="30">הבנק למסחר</option>
                                    </select>
                                    <div className={"validationError " + (stateErrors.bank && "on")}>{stateErrors.bank}</div>
                                </div>
                                <div className="row double">
                                    <div className="part">
                                        <label>מספר סניף</label>
                                        <input type="text" name="branch" inputMode="numeric" onChange={onFieldChange.bind(this, "branch")} className={stateErrors.branch && "error"}></input>
                                        <div className={"validationError " + (stateErrors.branch && "on")}>{stateErrors.branch}</div>
                                    </div>
                                    <div className="part">
                                        <label>מספר חשבון</label>
                                        <input type="text" name="account" inputMode="numeric" onChange={onFieldChange.bind(this, "account")} className={stateErrors.account && "error"}></input>
                                        <div className={"validationError " + (stateErrors.account && "on")}>{stateErrors.account}</div>
                                    </div>
                                </div>
                                <div className='txtBold'> לתשומת לבך <span className="redHeart">❤</span></div>
                                <div className="info">
                                    <div className="img"><img src="img/info.svg" alt="" /></div>
                                    <div className='txt'>מלבד הפרטים שלמעלה, נבקש לצרף בהמשך התהליך אישור ניהול חשבון בנק / צילום צ'ק.</div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="blueLine"></div>
                    <div className="dialog-buttons">
                        <button className="orange" onClick={handleSubmit}>אישור</button>
                        <button onClick={handleBack}>ביטול</button>
                    </div>
                </div>
            </Slide >
        </TSPage >
    );
}

export { BankDetailsPage }